import { useCallback, useEffect, useState } from "react";

interface SortQueueEntryInterface {
  columnName: string;
  isAscending: boolean;
  sortAsNumber: boolean;
}

const moduleState = {
  sortQueue: {} as Record<string, SortQueueEntryInterface[]>,
};

// +++ Default sort order +++
moduleState.sortQueue["ErrorsPage"] = [
  {
    columnName: "dateTimeAddedX",
    isAscending: false,
    sortAsNumber: false,
  },
];
// --- Default sort order ---

export type getClassOfColumnSortOrderType =
  | "sort-asc"
  | "sort-desc"
  | "sort-none";

type useSorterType = {
  pageName: string;
};

const useSorter = ({ pageName }: useSorterType) => {
  const [data, setData] = useState<any>();
  const [sortedData, setSortedData] = useState<any>();

  if (!moduleState.sortQueue[pageName]) {
    moduleState.sortQueue[pageName] = [];
  }

  const getClassOfColumnSortOrder: (
    columnName: string
  ) => getClassOfColumnSortOrderType = (columnName: string) => {
    const entry = moduleState.sortQueue[pageName]?.find(
      (item) => item.columnName === columnName
    );
    return entry ? (entry.isAscending ? "sort-asc" : "sort-desc") : "sort-none";
  };

  type StepSortOrderForColumnType = {
    columnName: string;
    cumulativeSort?: boolean;
    sortAsNumber?: boolean;
  };

  const stepSortOrderForColumn = ({
    columnName,
    cumulativeSort = true,
    sortAsNumber = false,
  }: StepSortOrderForColumnType) => {
    // console.log(
    //   "stepSortOrderForColumn[%o] A: %o",
    //   pageName,
    //   moduleState.sortQueue[pageName]
    // );

    const existingEntry = moduleState.sortQueue[pageName].find(
      (item) => item.columnName === columnName
    );

    if (existingEntry) {
      if (existingEntry.isAscending) {
        existingEntry.isAscending = false;
      } else {
        moduleState.sortQueue[pageName] = moduleState.sortQueue[
          pageName
        ].filter((item) => item.columnName !== columnName);
      }
    } else {
      if (cumulativeSort) {
        moduleState.sortQueue[pageName].unshift({
          columnName: columnName,
          isAscending: true,
          sortAsNumber: sortAsNumber,
        });
      } else {
        moduleState.sortQueue[pageName] = [
          {
            columnName: columnName,
            isAscending: true,
            sortAsNumber: sortAsNumber,
          },
        ];
      }
    }
    // console.log(
    //   "stepSortOrderForColumn[%o] B: %o",
    //   pageName,
    //   moduleState.sortQueue[pageName]
    // );
    doSortData();
  };

  const doSortData = useCallback(() => {
    if (!data) return;

    let sorted = [...data];
    moduleState.sortQueue[pageName].forEach((entry) => {
      sorted.sort((a, b) => {
        if (entry.sortAsNumber) {
          const aa = (
            entry.columnName
              .split(".")
              .reduce((acc, part) => acc && acc[part], a) || "-1"
          )
            .toString()
            .toLowerCase();
          const bb =
            entry.columnName
              .split(".")
              .reduce((acc, part) => acc && acc[part], b) || "-1";
          return entry.isAscending ? aa - bb : bb - aa;
        }

        const aa = (
          entry.columnName
            .split(".")
            .reduce((acc, part) => acc && acc[part], a) || ""
        )
          .toString()
          .toLowerCase();
        const bb = (
          entry.columnName
            .split(".")
            .reduce((acc, part) => acc && acc[part], b) || ""
        )
          .toString()
          .toLowerCase();

        if (aa < bb) {
          return entry.isAscending ? -1 : 1;
        }
        if (aa > bb) {
          return entry.isAscending ? 1 : -1;
        }
        return 0;
      });
    });
    setSortedData(sorted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    doSortData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    getClassOfColumnSortOrder,
    stepSortOrderForColumn,
    setData,
    sortedData: sortedData ?? data,
  };
};

export default useSorter;
